/**
 * We gather all the svgs here and export them to various locations.
 */

export const ICONS = {
  EMAIL: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
    >
      <path
        id="Icon_material-email"
        data-name="Icon material-email"
        d="M21,6H5A2,2,0,0,0,3.01,8L3,20a2.006,2.006,0,0,0,2,2H21a2.006,2.006,0,0,0,2-2V8A2.006,2.006,0,0,0,21,6Zm0,4-8,5L5,10V8l8,5,8-5Z"
        transform="translate(-3 -6)"
        fill="#fff"
      />
    </svg>
  ),
  GROUP_WORK: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        id="Icon_material-group-work"
        data-name="Icon material-group-work"
        d="M14,3A11,11,0,1,0,25,14,11,11,0,0,0,14,3ZM9.6,20.05a2.75,2.75,0,1,1,2.75-2.75A2.751,2.751,0,0,1,9.6,20.05ZM11.25,9.6A2.75,2.75,0,1,1,14,12.35,2.751,2.751,0,0,1,11.25,9.6ZM18.4,20.05a2.75,2.75,0,1,1,2.75-2.75A2.751,2.751,0,0,1,18.4,20.05Z"
        transform="translate(-3 -3)"
        fill="#fff"
      />
    </svg>
  ),
  SECURITY: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      viewBox="0 0 18 22"
    >
      <path
        id="Icon_material-security"
        data-name="Icon material-security"
        d="M13.5,1.5l-9,4v6c0,5.55,3.84,10.74,9,12,5.16-1.26,9-6.45,9-12v-6Zm0,10.99h7c-.53,4.12-3.28,7.79-7,8.94V12.5h-7V6.8l7-3.11Z"
        transform="translate(-4.5 -1.5)"
        fill="#fff"
      />
    </svg>
  ),
  USER: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        id="Icon_awesome-user-alt"
        data-name="Icon awesome-user-alt"
        d="M11,12.375A6.188,6.188,0,1,0,4.813,6.188,6.189,6.189,0,0,0,11,12.375Zm5.5,1.375H14.132a7.48,7.48,0,0,1-6.265,0H5.5A5.5,5.5,0,0,0,0,19.25v.688A2.063,2.063,0,0,0,2.063,22H19.938A2.063,2.063,0,0,0,22,19.938V19.25A5.5,5.5,0,0,0,16.5,13.75Z"
        fill="#fff"
      />
    </svg>
  ),
  PHONE: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        id="Icon_awesome-phone-alt"
        data-name="Icon awesome-phone-alt"
        d="M19.43,14.133l-4.375-1.875a.938.938,0,0,0-1.094.27l-1.938,2.367A14.479,14.479,0,0,1,5.1,7.973L7.469,6.036a.935.935,0,0,0,.27-1.094L5.863.567A.944.944,0,0,0,4.789.024L.727.962A.938.938,0,0,0,0,1.875,18.123,18.123,0,0,0,18.125,20a.938.938,0,0,0,.914-.727l.938-4.063a.949.949,0,0,0-.547-1.078Z"
        transform="translate(0 0)"
        fill="#fff"
      />
    </svg>
  ),
  HOME: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="17.108"
      viewBox="0 0 22 17.108"
    >
      <path
        id="Icon_awesome-home"
        data-name="Icon awesome-home"
        d="M10.707,6.692l-7.041,5.8V18.75a.611.611,0,0,0,.611.611l4.28-.011a.611.611,0,0,0,.608-.611V15.084a.611.611,0,0,1,.611-.611H12.22a.611.611,0,0,1,.611.611v3.653a.611.611,0,0,0,.611.613l4.278.012a.611.611,0,0,0,.611-.611V12.487l-7.04-5.8A.466.466,0,0,0,10.707,6.692ZM21.83,10.633,18.637,8V2.712a.458.458,0,0,0-.458-.458H16.04a.458.458,0,0,0-.458.458V5.485L12.162,2.672a1.833,1.833,0,0,0-2.33,0L.165,10.633a.458.458,0,0,0-.061.645l.974,1.184a.458.458,0,0,0,.646.062l8.983-7.4a.466.466,0,0,1,.584,0l8.984,7.4a.458.458,0,0,0,.645-.061l.974-1.184a.458.458,0,0,0-.065-.647Z"
        transform="translate(0.001 -2.254)"
        fill="#fff"
      />
    </svg>
  ),
  EXCLUSION: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.4"
      height="21.999"
      viewBox="0 0 15.4 21.999"
    >
      <path
        id="Exclusion_1"
        data-name="Exclusion 1"
        d="M-6183.3-2440h0a50.774,50.774,0,0,1-3.849-4.983c-1.756-2.6-3.85-6.333-3.85-9.316a7.708,7.708,0,0,1,7.7-7.7,7.708,7.708,0,0,1,7.7,7.7c0,2.983-2.094,6.713-3.85,9.316A50.758,50.758,0,0,1-6183.3-2440Zm-.2-18.5a3,3,0,0,0-3,3,3,3,0,0,0,3,3,3,3,0,0,0,3-3A3,3,0,0,0-6183.5-2458.5Z"
        transform="translate(6191 2461.999)"
        fill="#fff"
      />
    </svg>
  ),
  LANGUAGE_ICON: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Icon_material-language"
        data-name="Icon material-language"
        d="M14.988,3A12,12,0,1,0,27,15,11.994,11.994,0,0,0,14.988,3ZM23.3,10.2h-3.54a18.779,18.779,0,0,0-1.656-4.272A9.636,9.636,0,0,1,23.3,10.2ZM15,5.448A16.9,16.9,0,0,1,17.292,10.2H12.708A16.9,16.9,0,0,1,15,5.448ZM5.712,17.4a9.387,9.387,0,0,1,0-4.8H9.768A19.818,19.818,0,0,0,9.6,15a19.818,19.818,0,0,0,.168,2.4ZM6.7,19.8h3.54a18.779,18.779,0,0,0,1.656,4.272A9.584,9.584,0,0,1,6.7,19.8Zm3.54-9.6H6.7a9.584,9.584,0,0,1,5.2-4.272A18.779,18.779,0,0,0,10.236,10.2ZM15,24.552A16.9,16.9,0,0,1,12.708,19.8h4.584A16.9,16.9,0,0,1,15,24.552ZM17.808,17.4H12.192A17.655,17.655,0,0,1,12,15a17.5,17.5,0,0,1,.192-2.4h5.616A17.5,17.5,0,0,1,18,15,17.655,17.655,0,0,1,17.808,17.4Zm.3,6.672A18.779,18.779,0,0,0,19.764,19.8H23.3A9.636,9.636,0,0,1,18.108,24.072ZM20.232,17.4A19.818,19.818,0,0,0,20.4,15a19.819,19.819,0,0,0-.168-2.4h4.056a9.387,9.387,0,0,1,0,4.8Z"
        transform="translate(-3 -3)"
        fill="#fff"
      />
    </svg>
  ),
  LANGUAGE_ARROW: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.469"
      height="13.124"
      viewBox="0 0 14.469 13.124"
    >
      <path
        id="Path_1510"
        data-name="Path 1510"
        d="M6.92,4.345a3,3,0,0,1,5.159,0l4.23,7.124A3,3,0,0,1,13.73,16H5.27a3,3,0,0,1-2.58-4.532Z"
        transform="translate(16.734 16) rotate(180)"
        fill="#fff"
      />
    </svg>
  ),
  LOGOUT: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 28C5.93333 28 5.30533 27.7391 4.78267 27.2173C4.26089 26.6947 4 26.0667 4 25.3333V6.66667C4 5.93333 4.26089 5.30533 4.78267 4.78267C5.30533 4.26089 5.93333 4 6.66667 4H16V6.66667H6.66667V25.3333H16V28H6.66667ZM21.3333 22.6667L19.5 20.7333L22.9 17.3333H12V14.6667H22.9L19.5 11.2667L21.3333 9.33333L28 16L21.3333 22.6667Z"
        fill="white"
      />
    </svg>
  ),
  LOGIN: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 28V25.3333H25.3333V6.66667H16V4H25.3333C26.0667 4 26.6947 4.26089 27.2173 4.78267C27.7391 5.30533 28 5.93333 28 6.66667V25.3333C28 26.0667 27.7391 26.6947 27.2173 27.2173C26.6947 27.7391 26.0667 28 25.3333 28H16ZM13.3333 22.6667L11.5 20.7333L14.9 17.3333H4V14.6667H14.9L11.5 11.2667L13.3333 9.33333L20 16L13.3333 22.6667Z"
        fill="white"
      />
    </svg>
  ),
  FILE: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <path
        d="M17.152,8.955l-1.4-1.395L8.778,14.537a2.96,2.96,0,0,0,4.187,4.186l8.374-8.373a4.934,4.934,0,0,0-6.978-6.977L5.569,12.164l-.019.018a6.881,6.881,0,1,0,9.732,9.73l.018-.019h0l6-6-1.4-1.395-6,6-.018.018a4.907,4.907,0,0,1-6.941-6.939l.019-.018h0l8.793-8.791a2.96,2.96,0,1,1,4.187,4.186L11.57,17.327a.987.987,0,1,1-1.4-1.395l6.978-6.978Z"
        transform="translate(-3.535 -1.928)"
        fill="#fff"
        opacity="0.591"
      />
    </svg>
  ),

  REMOVE: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.444"
      height="16"
      viewBox="0 0 12.444 16"
    >
      <path
        d="M8.389,18.722A1.783,1.783,0,0,0,10.167,20.5h7.111a1.783,1.783,0,0,0,1.778-1.778V8.056H8.389ZM19.944,5.389H16.833L15.944,4.5H11.5l-.889.889H7.5V7.167H19.944Z"
        transform="translate(-7.5 -4.5)"
        fill="#f84e4e"
      />
    </svg>
  ),
  //   CHAT_ICON: (
  //     <svg
  //       width="200"
  //       height="200"
  //       viewBox="0 0 200 200"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <g filter="url(#filter0_d_395_31013)">
  //         <rect x="4" width="192" height="192" rx="96" fill="#F0F2F5" />
  //         <rect x="28" y="27" width="144" height="143" rx="71.5" fill="#F0F2F5" />
  //         <path
  //           d="M89.9287 94C89.9287 96.6711 90.9898 99.2328 92.8785 101.122C94.7673 103.01 97.3289 104.071 100 104.071C102.671 104.071 105.233 103.01 107.121 101.122C109.01 99.2328 110.071 96.6711 110.071 94C110.071 91.3289 109.01 88.7672 107.121 86.8784C105.233 84.9897 102.671 83.9286 100 83.9286C97.3289 83.9286 94.7673 84.9897 92.8785 86.8784C90.9898 88.7672 89.9287 91.3289 89.9287 94ZM131.892 94C131.892 96.6711 132.954 99.2328 134.842 101.122C136.731 103.01 139.293 104.071 141.964 104.071C144.635 104.071 147.197 103.01 149.085 101.122C150.974 99.2328 152.035 96.6711 152.035 94C152.035 91.3289 150.974 88.7672 149.085 86.8784C147.197 84.9897 144.635 83.9286 141.964 83.9286C139.293 83.9286 136.731 84.9897 134.842 86.8784C132.954 88.7672 131.892 91.3289 131.892 94ZM47.9649 94C47.9649 96.6711 49.026 99.2328 50.9148 101.122C52.8035 103.01 55.3652 104.071 58.0363 104.071C60.7073 104.071 63.269 103.01 65.1577 101.122C67.0465 99.2328 68.1076 96.6711 68.1076 94C68.1076 91.3289 67.0465 88.7672 65.1577 86.8784C63.269 84.9897 60.7073 83.9286 58.0363 83.9286C55.3652 83.9286 52.8035 84.9897 50.9148 86.8784C49.026 88.7672 47.9649 91.3289 47.9649 94ZM186.697 57.575C181.955 46.3076 175.157 36.1942 166.492 27.5076C157.887 18.8713 147.672 12.0064 136.425 7.30179C124.885 2.45491 112.631 0 100 0H99.5804C86.8654 0.0629464 74.549 2.5808 62.967 7.53259C51.8163 12.2855 41.6969 19.1625 33.1727 27.7804C24.5911 36.446 17.856 46.5174 13.198 57.7429C8.37214 69.367 5.93824 81.7254 6.00119 94.4406C6.07239 109.012 9.51968 123.369 16.0725 136.384V168.277C16.0725 170.837 17.0894 173.292 18.8994 175.102C20.7094 176.912 23.1644 177.929 25.7242 177.929H57.6376C70.6525 184.481 85.0091 187.929 99.5804 188H100.021C112.589 188 124.78 185.566 136.257 180.803C147.447 176.155 157.624 169.37 166.219 160.828C174.884 152.246 181.703 142.217 186.466 131.033C191.418 119.451 193.936 107.135 193.999 94.4196C194.062 81.6415 191.586 69.2411 186.697 57.575ZM154.994 149.477C140.285 164.038 120.772 172.054 100 172.054H99.6433C86.9912 171.991 74.4231 168.843 63.3237 162.926L61.5612 161.982H32.0187V132.439L31.0745 130.677C25.1576 119.577 22.0104 107.009 21.9474 94.3567C21.8635 73.4375 29.8576 53.7982 44.5239 39.0058C59.1693 24.2134 78.7454 16.0304 99.6643 15.9464H100.021C110.512 15.9464 120.688 17.9817 130.277 22.0103C139.635 25.9339 148.028 31.5781 155.245 38.796C162.442 45.9929 168.107 54.4067 172.031 63.7647C176.101 73.4585 178.137 83.7397 178.095 94.3567C177.969 115.255 169.765 134.831 154.994 149.477Z"
  //           fill="#F0F2F5"
  //         />
  //       </g>
  //       <rect
  //         x="60.9883"
  //         y="48.3247"
  //         width="78.8323"
  //         height="93.6134"
  //         fill="url(#pattern0)"
  //       />
  //       <defs>
  //         <filter
  //           id="filter0_d_395_31013"
  //           x="0"
  //           y="0"
  //           width="200"
  //           height="200"
  //           filterUnits="userSpaceOnUse"
  //           color-interpolation-filters="sRGB"
  //         >
  //           <feFlood flood-opacity="0" result="BackgroundImageFix" />
  //           <feColorMatrix
  //             in="SourceAlpha"
  //             type="matrix"
  //             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  //             result="hardAlpha"
  //           />
  //           <feOffset dy="4" />
  //           <feGaussianBlur stdDeviation="2" />
  //           <feComposite in2="hardAlpha" operator="out" />
  //           <feColorMatrix
  //             type="matrix"
  //             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  //           />
  //           <feBlend
  //             mode="normal"
  //             in2="BackgroundImageFix"
  //             result="effect1_dropShadow_395_31013"
  //           />
  //           <feBlend
  //             mode="normal"
  //             in="SourceGraphic"
  //             in2="effect1_dropShadow_395_31013"
  //             result="shape"
  //           />
  //         </filter>
  //         <pattern
  //           id="pattern0"
  //           patternContentUnits="objectBoundingBox"
  //           width="1"
  //           height="1"
  //         >
  //           <use
  //             transform="translate(-0.00240387) scale(0.00260989 0.0021978)"
  //           />
  //         </pattern>
  //       </defs>
  //     </svg>
  //   ),
  CHAT_SENT_BUTTON: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      // fill="#4CE147"
    >
      <path d="M29.55 25.1875L17.725 4.07499C17.5511 3.7654 17.2979 3.50769 16.9914 3.32833C16.685 3.14898 16.3363 3.05444 15.9812 3.05444C15.6261 3.05444 15.2774 3.14898 14.971 3.32833C14.6645 3.50769 14.4114 3.7654 14.2375 4.07499L2.41246 25.1875C2.21047 25.5413 2.12361 25.9492 2.16393 26.3546C2.20425 26.7601 2.36974 27.1429 2.63746 27.45C2.89825 27.7637 3.24927 27.9895 3.64285 28.0969C4.03643 28.2042 4.4535 28.1879 4.83746 28.05L14.65 24.5375C14.7478 24.502 14.8325 24.4375 14.8928 24.3526C14.9531 24.2678 14.9861 24.1666 14.9875 24.0625V15.0375C14.9831 14.78 15.0758 14.5302 15.2472 14.338C15.4186 14.1457 15.6561 14.0251 15.9125 14C16.0499 13.9896 16.1881 14.0078 16.3182 14.0535C16.4483 14.0991 16.5676 14.1711 16.6686 14.265C16.7695 14.3589 16.85 14.4727 16.9048 14.5992C16.9597 14.7256 16.9878 14.8621 16.9875 15V24.0625C16.9861 24.1655 17.0166 24.2664 17.0748 24.3514C17.1329 24.4365 17.2159 24.5014 17.3125 24.5375L27.1375 28.05C27.3549 28.1237 27.5829 28.1617 27.8125 28.1625C28.1604 28.161 28.5018 28.0687 28.8032 27.8949C29.1045 27.721 29.3553 27.4716 29.5308 27.1712C29.7062 26.8707 29.8003 26.5297 29.8036 26.1819C29.807 25.834 29.7196 25.4912 29.55 25.1875Z" />
    </svg>
  ),
  CHECKED: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="#25F662"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" rx="11" />
      <path
        d="M9.89988 15.8423C10.2309 15.8423 10.4891 15.7132 10.6686 15.4439L15.9208 7.31866C16.0555 7.11666 16.106 6.93709 16.106 6.76314C16.106 6.31985 15.7806 6 15.326 6C15.0118 6 14.821 6.11223 14.6302 6.41524L9.87743 13.9457L7.44211 10.8594C7.25694 10.6294 7.06615 10.5283 6.7912 10.5283C6.33107 10.5283 6 10.8538 6 11.3027C6 11.4991 6.06734 11.6843 6.23006 11.8807L9.13674 15.4607C9.34997 15.7244 9.58564 15.8423 9.89988 15.8423Z"
        fill="white"
      />
    </svg>
  ),
  DELETE: (
    <svg
      width="21"
      height="23"
      viewBox="0 0 21 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.9375 3.6875H12.0625C12.0625 3.2731 11.8979 2.87567 11.6049 2.58265C11.3118 2.28962 10.9144 2.125 10.5 2.125C10.0856 2.125 9.68817 2.28962 9.39515 2.58265C9.10212 2.87567 8.9375 3.2731 8.9375 3.6875ZM7.375 3.6875C7.375 2.8587 7.70424 2.06384 8.29029 1.47779C8.87634 0.89174 9.6712 0.5625 10.5 0.5625C11.3288 0.5625 12.1237 0.89174 12.7097 1.47779C13.2958 2.06384 13.625 2.8587 13.625 3.6875H19.875C20.0822 3.6875 20.2809 3.76981 20.4274 3.91632C20.5739 4.06284 20.6562 4.26155 20.6562 4.46875C20.6562 4.67595 20.5739 4.87466 20.4274 5.02118C20.2809 5.16769 20.0822 5.25 19.875 5.25H18.9937L17.1109 19.0594C16.9832 19.9952 16.5208 20.8531 15.8092 21.4742C15.0976 22.0953 14.1851 22.4375 13.2406 22.4375H7.75937C6.81487 22.4375 5.90236 22.0953 5.19078 21.4742C4.47921 20.8531 4.01676 19.9952 3.88906 19.0594L2.00625 5.25H1.125C0.9178 5.25 0.719086 5.16769 0.572573 5.02118C0.42606 4.87466 0.34375 4.67595 0.34375 4.46875C0.34375 4.26155 0.42606 4.06284 0.572573 3.91632C0.719086 3.76981 0.9178 3.6875 1.125 3.6875H7.375ZM8.9375 9.15625C8.9375 8.94905 8.85519 8.75034 8.70868 8.60382C8.56216 8.45731 8.36345 8.375 8.15625 8.375C7.94905 8.375 7.75034 8.45731 7.60382 8.60382C7.45731 8.75034 7.375 8.94905 7.375 9.15625V16.9688C7.375 17.176 7.45731 17.3747 7.60382 17.5212C7.75034 17.6677 7.94905 17.75 8.15625 17.75C8.36345 17.75 8.56216 17.6677 8.70868 17.5212C8.85519 17.3747 8.9375 17.176 8.9375 16.9688V9.15625ZM12.8438 8.375C12.6365 8.375 12.4378 8.45731 12.2913 8.60382C12.1448 8.75034 12.0625 8.94905 12.0625 9.15625V16.9688C12.0625 17.176 12.1448 17.3747 12.2913 17.5212C12.4378 17.6677 12.6365 17.75 12.8438 17.75C13.051 17.75 13.2497 17.6677 13.3962 17.5212C13.5427 17.3747 13.625 17.176 13.625 16.9688V9.15625C13.625 8.94905 13.5427 8.75034 13.3962 8.60382C13.2497 8.45731 13.051 8.375 12.8438 8.375Z"
        fill="white"
      />
    </svg>
  ),
  PLAYLIST_EDIT: (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9583 3.625C23.5993 3.625 24.214 3.87961 24.6672 4.33283C25.1204 4.78604 25.375 5.40073 25.375 6.04167V22.9583C25.375 23.5993 25.1204 24.214 24.6672 24.6672C24.214 25.1204 23.5993 25.375 22.9583 25.375H6.04167C5.40073 25.375 4.78604 25.1204 4.33283 24.6672C3.87961 24.214 3.625 23.5993 3.625 22.9583V6.04167C3.625 5.40073 3.87961 4.78604 4.33283 4.33283C4.78604 3.87961 5.40073 3.625 6.04167 3.625H22.9583ZM20.1792 11.2979C20.445 11.0442 20.445 10.6213 20.1792 10.3675L18.6325 8.82083C18.5725 8.75788 18.5003 8.70777 18.4203 8.67353C18.3404 8.63929 18.2543 8.62164 18.1673 8.62164C18.0803 8.62164 17.9942 8.63929 17.9143 8.67353C17.8343 8.70777 17.7621 8.75788 17.7021 8.82083L16.4937 10.0292L18.9708 12.5063L20.1792 11.2979ZM8.45833 18.0525V20.5417H10.9475L18.27 13.2192L15.7808 10.73L8.45833 18.0525Z"
        fill="white"
      />
    </svg>
  ),
  ADD: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18.6667C12.3778 18.6667 12.6947 18.5387 12.9507 18.2827C13.2058 18.0276 13.3333 17.7111 13.3333 17.3333V13.3333H17.3333C17.7111 13.3333 18.0276 13.2053 18.2827 12.9493C18.5387 12.6942 18.6667 12.3778 18.6667 12C18.6667 11.6222 18.5387 11.3053 18.2827 11.0493C18.0276 10.7942 17.7111 10.6667 17.3333 10.6667H13.3333V6.66667C13.3333 6.28889 13.2058 5.972 12.9507 5.716C12.6947 5.46089 12.3778 5.33333 12 5.33333C11.6222 5.33333 11.3058 5.46089 11.0507 5.716C10.7947 5.972 10.6667 6.28889 10.6667 6.66667V10.6667H6.66667C6.28889 10.6667 5.972 10.7942 5.716 11.0493C5.46089 11.3053 5.33333 11.6222 5.33333 12C5.33333 12.3778 5.46089 12.6942 5.716 12.9493C5.972 13.2053 6.28889 13.3333 6.66667 13.3333H10.6667V17.3333C10.6667 17.7111 10.7947 18.0276 11.0507 18.2827C11.3058 18.5387 11.6222 18.6667 12 18.6667ZM2.66667 24C1.93333 24 1.30533 23.7391 0.782666 23.2173C0.260889 22.6947 0 22.0667 0 21.3333V2.66667C0 1.93333 0.260889 1.30533 0.782666 0.782666C1.30533 0.260889 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6947 0.260889 23.2173 0.782666C23.7391 1.30533 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7391 22.6947 23.2173 23.2173C22.6947 23.7391 22.0667 24 21.3333 24H2.66667Z"
        fill="white"
      />
    </svg>
  ),
  IOS: (
    <svg
      width="110"
      height="38"
      viewBox="0 0 110 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.95767 5.34375C1.31711 5.34375 0.0185547 6.62627 0.0185547 8.22942C0.018489 8.61291 0.0948623 8.99257 0.243211 9.34621C0.39156 9.69984 0.608909 10.0204 0.882554 10.289C1.1562 10.5577 1.48065 10.7691 1.83695 10.911C2.19325 11.0528 2.57424 11.1222 2.95767 11.1151C4.61426 11.1151 5.9235 9.83257 5.9235 8.22942C5.9235 6.62627 4.61426 5.34375 2.95767 5.34375ZM23.291 5.39719C14.3133 5.39719 8.70229 11.5159 8.70229 21.2417C8.70229 31.0476 14.3133 37.1396 23.291 37.1396C32.2152 37.1396 37.8529 31.0476 37.8529 21.2417C37.8529 11.5159 32.2152 5.39719 23.291 5.39719ZM52.2546 5.39719C45.5748 5.39719 40.8188 9.08444 40.8188 14.5619C40.8188 18.9171 43.5174 21.6425 49.1819 22.9517L53.163 23.9136C57.0373 24.7953 58.6138 26.0778 58.6138 28.2955C58.6138 30.8606 56.022 32.6775 52.3347 32.6775C48.5673 32.6775 45.7351 30.8339 45.4412 28.0016H40.0974C40.3111 33.6661 44.9602 37.1396 52.0141 37.1396C59.4688 37.1396 64.1446 33.4791 64.1446 27.6543C64.1446 23.0853 61.4727 20.4935 55.2739 19.0774L51.7202 18.2758C47.9528 17.3674 46.4031 16.165 46.4031 14.1344C46.4031 11.5693 48.7544 9.85929 52.2279 9.85929C55.7281 9.85929 58.1328 11.596 58.4 14.455H63.637C63.5034 9.05772 59.0413 5.39719 52.2546 5.39719ZM23.291 10.073C28.7417 10.073 32.2419 14.4283 32.2419 21.2417C32.2419 28.1085 28.7417 32.4637 23.291 32.4637C17.7868 32.4637 14.3133 28.1085 14.3133 21.2417C14.3133 14.4283 17.7868 10.073 23.291 10.073ZM0.315138 14.0542V36.6319H5.62959V14.0542H0.312466H0.315138Z"
        fill="white"
      />
      <path
        d="M104.284 19.8764C104.3 18.4447 104.699 17.0404 105.442 15.7949C106.186 14.5494 107.249 13.5034 108.534 12.7549C107.717 11.6503 106.642 10.7407 105.393 10.0973C104.144 9.45403 102.754 9.09454 101.334 9.04712C98.2682 8.75129 95.3512 10.7622 93.7943 10.7622C92.2374 10.7622 89.8399 9.09067 87.2992 9.12878C85.6296 9.17335 84.0008 9.62959 82.5727 10.4527C81.1447 11.2758 79.9665 12.4375 79.1537 13.8238C75.6807 19.5479 78.2635 28.0288 81.6485 32.6712C83.3028 34.9435 85.2781 37.497 87.8628 37.4044C90.3557 37.3101 91.3013 35.8709 94.3139 35.8709C97.3264 35.8709 98.1765 37.4044 100.809 37.3572C103.483 37.3101 105.191 35.0415 106.834 32.762C108.01 31.1207 108.931 29.3267 109.568 27.4354C108.007 26.8026 106.675 25.7497 105.736 24.4066C104.797 23.0635 104.292 21.4887 104.284 19.8764ZM99.317 5.97454C100.803 4.31789 101.539 2.17025 101.365 0C99.1218 0.206433 97.0469 1.22 95.5651 2.83301C94.8259 3.61526 94.2598 4.53073 93.9005 5.52498C93.5411 6.51923 93.3959 7.57197 93.4733 8.62062C94.5975 8.63737 95.7106 8.4073 96.7259 7.94833C97.7411 7.48936 98.6311 6.81389 99.3265 5.97454H99.317Z"
        fill="white"
      />
    </svg>
  ),
  ANDROID: (
    <svg
      width="243"
      height="38"
      viewBox="0 0 243 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1527_2515)">
        <path
          d="M11.6137 12.0643C15.084 12.0643 17.9662 13.8551 19.3375 15.786V12.5397H24.6265V36.6349H20.8209C20.6222 36.6358 20.4253 36.5973 20.2415 36.5216C20.0577 36.446 19.8908 36.3347 19.7503 36.1942C19.6097 36.0537 19.4984 35.8867 19.4228 35.7029C19.3471 35.5191 19.3086 35.3222 19.3095 35.1235V33.3886C17.9662 35.3474 15.084 37.1387 11.6137 37.1387C5.00968 37.1387 0 31.4855 0 24.6013C0 17.7165 5.00968 12.0643 11.6137 12.0643ZM12.5654 16.8774C8.28349 16.8774 5.37286 20.2635 5.37286 24.6013C5.37286 28.9386 8.25556 32.3251 12.5654 32.3251C16.8468 32.3251 19.7575 28.939 19.7575 24.6013C19.7575 20.264 16.8748 16.8774 12.5649 16.8774M30.6433 12.5397H35.9608V15.814C37.4159 13.4071 40.1584 12.0638 43.293 12.0638C48.8898 12.0638 52.4998 16.01 52.4998 22.1386V36.6344H48.6938C48.4951 36.6352 48.2982 36.5967 48.1145 36.521C47.9308 36.4454 47.7639 36.334 47.6234 36.1935C47.4829 36.053 47.3717 35.8861 47.2961 35.7023C47.2205 35.5186 47.182 35.3217 47.1829 35.123V23.007C47.1829 19.2005 45.2519 16.8779 42.1732 16.8779C38.6475 16.8779 35.9608 19.6205 35.9608 24.7693V36.6354H32.1548C31.9561 36.6362 31.7592 36.5977 31.5755 36.522C31.3918 36.4463 31.2248 36.335 31.0844 36.1945C30.9439 36.054 30.8326 35.887 30.757 35.7033C30.6814 35.5195 30.6429 35.3226 30.6438 35.124L30.6433 12.5397ZM68.3116 12.0638C71.7814 12.0638 74.6641 13.8551 76.0354 15.7855V0.50602H81.3244V36.6628H77.5184C77.3197 36.6637 77.1228 36.6251 76.9391 36.5494C76.7554 36.4738 76.5885 36.3625 76.448 36.2219C76.3075 36.0814 76.1963 35.9145 76.1207 35.7307C76.0451 35.547 76.0066 35.3501 76.0074 35.1514V33.4165C74.6641 35.3474 71.7535 37.1382 68.2836 37.1382C61.6792 37.1382 56.6695 31.4855 56.6695 24.6013C56.6979 17.7165 61.7071 12.0638 68.3116 12.0638ZM69.2633 16.8774C64.9814 16.8774 62.0708 20.2635 62.0708 24.6013C62.0708 28.9386 64.9535 32.3251 69.2633 32.3251C73.5448 32.3251 76.4549 28.939 76.4549 24.6013C76.4549 20.264 73.5448 16.8774 69.2628 16.8774M87.3413 12.5397H92.6303V16.8216C93.5536 14.079 96.2408 12.2878 98.9833 12.2878C99.6548 12.2878 100.326 12.3436 101.054 12.4838V17.9405C100.131 17.6606 99.3749 17.4925 98.3952 17.4925C95.3449 17.4925 92.6024 20.039 92.6024 24.8806V36.6344H88.7963C88.5977 36.6352 88.4008 36.5967 88.2171 36.521C88.0333 36.4454 87.8664 36.334 87.7259 36.1935C87.5855 36.053 87.4742 35.8861 87.3986 35.7023C87.323 35.5186 87.2845 35.3217 87.2854 35.123V12.5397H87.3413ZM115.382 37.1382C108.246 37.1382 102.761 31.5973 102.761 24.6013C102.761 17.6047 108.246 12.0638 115.382 12.0638C122.518 12.0638 128.003 17.6047 128.003 24.6013C128.003 31.5973 122.518 37.1382 115.382 37.1382ZM115.382 32.2133C119.636 32.2133 122.603 28.8827 122.603 24.6013C122.603 20.3194 119.608 16.9892 115.382 16.9892C111.101 16.9892 108.106 20.3194 108.106 24.6013C108.106 28.8827 111.101 32.2133 115.382 32.2133ZM134.944 7.27856C133.013 7.27856 131.39 5.68332 131.39 3.72443C131.39 1.79348 133.041 0.198242 134.944 0.198242C136.931 0.198242 138.47 1.79348 138.47 3.72443C138.47 5.71126 136.931 7.27856 134.944 7.27856ZM132.313 12.5397H137.602V36.6349H133.824C133.626 36.6357 133.429 36.5972 133.245 36.5215C133.061 36.4458 132.894 36.3345 132.754 36.194C132.613 36.0535 132.502 35.8865 132.427 35.7028C132.351 35.5191 132.312 35.3222 132.313 35.1235V12.5397ZM153.582 12.0638C157.052 12.0638 159.935 13.8551 161.306 15.7855V0.50602H166.595V36.6628H162.789C162.59 36.6637 162.393 36.6252 162.21 36.5496C162.026 36.4739 161.859 36.3626 161.718 36.2221C161.578 36.0816 161.467 35.9146 161.391 35.7308C161.315 35.5471 161.277 35.3501 161.278 35.1514V33.4165C159.935 35.3474 157.024 37.1382 153.554 37.1382C146.949 37.1382 141.94 31.4855 141.94 24.6013C141.969 17.7165 146.977 12.0638 153.582 12.0638ZM154.561 16.8774C150.28 16.8774 147.369 20.2635 147.369 24.6013C147.369 28.9386 150.252 32.3251 154.561 32.3251C158.843 32.3251 161.754 28.939 161.754 24.6013C161.754 20.264 158.843 16.8774 154.561 16.8774Z"
          fill="white"
        />
        <path
          d="M225.112 27.5396C224.399 27.5394 223.716 27.2563 223.212 26.7525C222.708 26.2487 222.425 25.5654 222.425 24.8529C222.425 24.1404 222.708 23.4571 223.212 22.9533C223.716 22.4495 224.399 22.1664 225.112 22.1662C225.824 22.1664 226.508 22.4495 227.011 22.9533C227.515 23.4571 227.798 24.1404 227.798 24.8529C227.798 25.5654 227.515 26.2487 227.011 26.7525C226.508 27.2563 225.824 27.5394 225.112 27.5396ZM195.532 27.5396C194.819 27.5396 194.136 27.2565 193.632 26.7527C193.128 26.2488 192.845 25.5655 192.845 24.8529C192.845 24.1404 193.128 23.4571 193.632 22.9533C194.136 22.4495 194.819 22.1664 195.531 22.1662C196.244 22.1664 196.927 22.4495 197.431 22.9533C197.935 23.4571 198.218 24.1404 198.218 24.8529C198.218 25.5654 197.935 26.2487 197.431 26.7525C196.927 27.2563 196.244 27.5394 195.531 27.5396M226.063 11.42L231.436 2.15687C231.744 1.62512 231.548 0.953693 231.016 0.645915C230.485 0.338137 229.813 0.533694 229.505 1.06544L224.076 10.4408C219.934 8.53734 215.289 7.47433 210.336 7.47433C205.382 7.47433 200.709 8.53734 196.567 10.4124L191.138 1.0375C190.83 0.505757 190.159 0.309726 189.627 0.617978C189.095 0.925756 188.899 1.59719 189.207 2.12893L194.552 11.3921C185.373 16.4013 179.076 25.6919 178.153 36.6905H242.434C241.539 25.7204 235.27 16.4292 226.063 11.4196"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1527_2515">
          <rect
            width="242.434"
            height="37.4069"
            fill="white"
            transform="translate(0 0.198242)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  LG: (
    <svg
      width="85"
      height="38"
      viewBox="0 0 85 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.722 0.396606C13.7615 0.396606 9.00424 2.36714 5.49667 5.87472C1.98909 9.38229 0.0185547 14.1396 0.0185547 19.1C0.0185547 24.0605 1.98909 28.8178 5.49667 32.3254C9.00424 35.8329 13.7615 37.8035 18.722 37.8035C23.6195 37.7082 28.2842 35.6958 31.714 32.1986C35.1438 28.7014 37.0651 23.9984 37.0651 19.1C37.0651 14.2017 35.1438 9.49868 31.714 6.00148C28.2842 2.50428 23.6195 0.491874 18.722 0.396606ZM18.722 3.43954C18.8989 3.43954 19.274 3.43954 19.465 3.44662V4.90793C19.2174 4.90262 18.9697 4.89908 18.722 4.89732C16.8576 4.89266 15.0108 5.25771 13.2884 5.97133C11.566 6.68495 10.0022 7.73298 8.68738 9.05482C7.36491 10.3691 6.31646 11.9329 5.60279 13.6554C4.88913 15.3779 4.52445 17.2249 4.52988 19.0894C4.52988 22.8825 6.00535 26.4491 8.68738 29.124C10.0022 30.4459 11.566 31.4939 13.2884 32.2075C15.0108 32.9212 16.8576 33.2862 18.722 33.2815C22.3196 33.2749 25.7811 31.9057 28.4092 29.4496C31.0374 26.9934 32.637 23.6329 32.8858 20.0448V19.8325H23.1979V18.3818H33.7456L34.3719 18.3782V19.0894C34.3784 21.1453 33.9771 23.1821 33.1912 25.0819C32.4053 26.9817 31.2504 28.7068 29.7933 30.1572C28.3419 31.6154 26.6158 32.7715 24.7149 33.5586C22.814 34.3457 20.7759 34.7482 18.7185 34.7429C14.5433 34.7429 10.6158 33.1152 7.64359 30.1572C6.18717 28.7065 5.03292 26.9813 4.24763 25.0815C3.46233 23.1817 3.06158 21.1451 3.06857 19.0894C3.07325 14.939 4.72383 10.9598 7.65831 8.0247C10.5928 5.08957 14.5716 3.43808 18.722 3.43246V3.43954ZM75.5577 6.54616C67.738 6.54616 63.6265 10.8169 63.6265 18.9585C63.6265 27.0612 67.3417 31.4487 75.5152 31.4487C79.2658 31.4487 82.9421 30.4934 84.9377 29.0957V17.3627H75.2428V21.8705H79.7895V26.0988C78.9509 26.4172 77.3127 26.7392 75.7558 26.7392C70.7314 26.7392 69.0543 24.1846 69.0543 18.9974C69.0543 14.0509 70.6465 11.1353 75.678 11.1353C78.4732 11.1353 80.0655 12.0128 81.3852 13.69L84.8599 10.4984C82.744 7.46612 79.0323 6.54616 75.5541 6.54616H75.5577ZM45.79 6.90707V31.0878H62.9507V26.3819H51.3805V6.90354L45.79 6.90707ZM12.7493 10.8806C13.3452 10.8806 13.9167 11.1173 14.3381 11.5387C14.7594 11.96 14.9962 12.5315 14.9962 13.1274C14.9962 13.7233 14.7594 14.2948 14.3381 14.7161C13.9167 15.1375 13.3452 15.3742 12.7493 15.3742C12.1535 15.3742 11.582 15.1375 11.1606 14.7161C10.7392 14.2948 10.5025 13.7233 10.5025 13.1274C10.5025 12.5315 10.7392 11.96 11.1606 11.5387C11.582 11.1173 12.1535 10.8806 12.7493 10.8806ZM17.979 10.8877H19.465V25.8193H23.1873V27.2841H17.979V10.8877Z"
        fill="white"
      />
    </svg>
  ),
  SAMSUNG: (
    <svg
      width="241"
      height="38"
      viewBox="0 0 241 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.1014 29.3643C16.2634 28.7082 16.3686 27.6256 16.0366 26.7809C15.274 24.8466 12.5926 23.3615 9.65752 21.736C5.73593 19.5641 1.36128 17.1412 0.504441 13.0605C0.140026 11.3055 0.180517 9.91128 0.42346 8.35308C1.33855 2.65332 6.35127 0.594849 12.4896 0.594849C17.3647 0.594849 24.1104 1.78401 24.1104 9.39461V11.8549H15.5021V9.68985C15.5021 7.7872 14.3279 6.52423 12.3034 6.52423C10.1493 6.52423 9.39616 7.7462 9.15322 8.86974C9.03852 9.47778 9.04955 10.1033 9.18561 10.7068C9.60198 12.4457 12.2042 13.8396 15.1714 15.4289C19.1872 17.58 23.8714 20.089 24.7097 24.296C24.8554 25.0259 25.1632 27.0023 24.7421 30.0203C23.9242 35.8513 18.79 38 12.5544 38C6.06784 38 0.0185547 35.6463 0.0185547 27.8553V25.1653H9.27469V28.5523C9.27469 30.455 10.5866 31.718 12.7407 31.718C15.0405 31.718 15.818 30.5288 16.1014 29.3643ZM30.2984 36.2195L36.8252 2.38474L52.4813 2.37679L58.9668 36.2195H49.507L44.8226 5.51479H44.6243L39.8077 36.2195H30.2984ZM85.6523 28.2514L89.9897 2.38474L104.332 2.37679L105.109 36.2195H96.3099L96.0869 5.80873H95.8969L90.0145 36.2195H81.0835L75.2094 5.80079H75.0111L74.7963 36.2195H65.9893L66.7659 2.38474H81.1165L85.4457 28.2514H85.6523ZM154.842 31.644C157.279 31.644 158.028 29.949 158.201 29.0849C158.275 28.7027 158.284 28.1876 158.284 27.7306V1.55867H167.16V26.9247C167.162 27.7009 167.135 28.477 167.078 29.2511C166.46 35.8564 161.289 38 154.842 38C148.386 38 143.215 35.8564 142.597 29.2511C142.572 28.9021 142.506 27.5728 142.515 26.9247V1.55036H151.391V27.7223C151.383 28.1876 151.4 28.7027 151.474 29.0849C151.638 29.949 152.396 31.644 154.842 31.644ZM197.727 1.55867L198.204 29.3342H198.015L189.945 1.55867H176.935V36.571H185.556L185.079 7.83163H185.268L193.922 36.571H206.414V1.55867H197.727ZM227.988 31.2784C230.524 31.2784 231.414 29.6582 231.57 28.7027C231.644 28.3122 231.653 27.8137 231.653 27.3734V22.2221H228.054V17.0708H240.48V26.5591C240.48 27.2238 240.463 27.7057 240.356 28.8855C239.78 35.333 234.238 37.6344 228.021 37.6344C221.804 37.6344 216.271 35.333 215.686 28.8855C215.587 27.7057 215.562 27.2238 215.562 26.5591V11.6702C215.562 11.0387 215.645 9.92539 215.711 9.34379C216.493 2.72187 221.804 0.594874 228.021 0.594874C234.238 0.594874 239.689 2.70525 240.332 9.33548C240.447 10.4654 240.414 11.6619 240.414 11.6619V12.85H231.57V10.8643C231.57 10.8643 231.57 10.0334 231.463 9.51827C231.298 8.73726 230.64 6.94262 227.955 6.94262C225.403 6.94262 224.653 8.64587 224.464 9.51827C224.357 9.98355 224.316 10.615 224.316 11.1883V27.3651C224.316 27.8137 224.332 28.3122 224.398 28.7111C224.563 29.6582 225.452 31.2784 227.988 31.2784ZM126.536 29.3643C126.698 28.7082 126.804 27.6257 126.472 26.7809C125.709 24.8466 123.028 23.3616 120.092 21.736C116.171 19.5641 111.796 17.1412 110.939 13.0605C110.575 11.3055 110.615 9.91131 110.858 8.3531C111.773 2.65335 116.786 0.594874 122.925 0.594874C127.8 0.594874 134.545 1.78403 134.545 9.39464V11.855H125.937V9.68988C125.937 7.78723 124.763 6.52426 122.738 6.52426C120.584 6.52426 119.831 7.74622 119.588 8.86977C119.473 9.4778 119.484 10.1033 119.621 10.7068C120.037 12.4457 122.639 13.8396 125.606 15.429C129.622 17.58 134.306 20.0891 135.145 24.296C135.29 25.0259 135.598 27.0024 135.177 30.0204C134.359 35.8513 129.225 38 122.989 38C116.503 38 110.454 35.6463 110.454 27.8553V25.1653H119.71V28.5524C119.71 30.455 121.022 31.718 123.176 31.718C125.475 31.718 126.253 30.5288 126.536 29.3643Z"
        fill="white"
      />
    </svg>
  ),
};
